import { render, staticRenderFns } from "./GPathConfigAdd.vue?vue&type=template&id=1bcf8a0a"
import script from "./GPathConfigAdd.vue?vue&type=script&lang=js"
export * from "./GPathConfigAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./GPathConfigAdd.vue?vue&type=style&index=1&id=1bcf8a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports